import styled from 'styled-components';
// import { ReactComponent as LogoOld } from '../../logo.svg';
import Logo from '../../test-ledger-logo-2.png';

const CustomHeader = styled.div`
	padding: 5px 10px 0 10px;
`;

function HeaderName() {
	return (
		<>
			{/* <CustomHeader><a href="https://testledger.dev"><LogoOld /></a></CustomHeader> */}
			<CustomHeader>
				<a href="https://testledger.dev">
					<img src={Logo} width="350" height="150" alt="Test Ledger Logo" />
				</a>
			</CustomHeader>
			<hr />
		</>
	);
}

export default HeaderName;
